import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

// Services
import { AppConfigService } from '@core/services/app-config.service';
import { ImageService } from '@core/services/image.service';

// Apis
import { AppUnsubscribeService } from '@core/services/app/unsubscribe.service';
import { TopbarService } from '@core/services/layouts/topbar.service';

// Utils
import { Dic } from '@core/utils/dic.utils';

/** États du flux désinscription : chargement initial, confirmation en attente, succès, erreur. */
type UnsubscribeState = 'loading' | 'confirm' | 'success' | 'error';

/**
 * Page publique de désinscription.
 * Charge le contexte via `query` (affiche le message retourné), puis propose
 * de confirmer ou d'annuler. La confirmation appelle `action`.
 */
@Component({
	selector: 'app-unsubscribe',
	imports: [RouterModule],
	templateUrl: './unsubscribe.html',
	styleUrl: './unsubscribe.scss',
})
export class AppUnsubscribe implements OnInit {
	static dialog = false;

	protected readonly Dic = Dic;

	state = signal<UnsubscribeState>('loading');
	queryMessage = signal('');
	successMessage = signal('');
	errorMessage = signal('');
	confirming = signal(false);
	appIcon = '';
	currentLang = '';
	userEmail = signal('');
	userName = signal('');

	private key = '';

	constructor(
		private unsubscribeService: AppUnsubscribeService,
		private route: ActivatedRoute,
		private appConfig: AppConfigService,
		private imageService: ImageService,
		private topbarService: TopbarService,
	) {
		this.key = this.route.snapshot.queryParamMap.get('key') ?? '';
		this.appIcon = this.imageService.getAppIcon();
		this.currentLang = this.appConfig.language;
	}

	ngOnInit(): void {
		if (!this.key) {
			this.errorMessage.set('Lien invalide ou expiré.');
			this.state.set('error');
			return;
		}
		this.unsubscribeService.query(this.key).subscribe({
			next: (response: any) => {
				this.queryMessage.set(response?.data?.message ?? '');
				this.userEmail.set(response?.data?.email ?? '');
				this.userName.set(response?.data?.person ?? '');
				this.state.set('confirm');
			},
			error: (err) => {
				this.errorMessage.set(err?.error?.message ?? 'Une erreur est survenue.');
				this.state.set('error');
			},
		});
	}

	setLanguage(lang: string): void {
		this.topbarService.setLanguage(lang).subscribe({
			next: () => window.location.reload(),
			error: (err) => console.error('Erreur changement de langue:', err),
		});
	}

	confirm(): void {
		this.confirming.set(true);
		this.unsubscribeService.action('confirmunsubscribe', this.key).subscribe({
			next: (response: any) => {
				this.successMessage.set(response?.messageok ?? '');
				this.state.set('success');
				this.confirming.set(false);
			},
			error: (err) => {
				this.errorMessage.set(err?.error?.message ?? 'Une erreur est survenue.');
				this.state.set('error');
				this.confirming.set(false);
			},
		});
	}
}
